export function parseTextList(value) {
    return String(value || '')
        .split(/\r?\n/)
        .map(item => item.trim())
        .filter(Boolean);
}

export function parseRubricLines(value) {
    return String(value || '')
        .split(/\r?\n/)
        .map((line, index) => {
            const raw = line.trim();
            if (!raw) return null;
            const parts = raw.includes('|')
                ? raw.split('|').map(part => part.trim())
                : raw.split(',').map(part => part.trim());
            const title = parts[0];
            const points = Number(parts[1]);
            if (!title || !Number.isFinite(points) || points <= 0) {
                throw new Error('Rubric lines must use: Criterion | points | optional description');
            }
            return {
                id: `criterion-${index + 1}`,
                title,
                points,
                description: parts.slice(2).join(' | ') || null,
            };
        })
        .filter(Boolean);
}

export function rubricPointsTotal(criteria) {
    return (criteria || []).reduce((total, item) => total + (Number(item.points) || 0), 0);
}
